import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Dispatch } from 'redux';
import { setRange } from '../../store/actions/timelineActions';
import * as Selectors from '../../store/selectors';
import { ApplicationState, DateRangeNavigatorFunctions } from '../../store/types';
import FixedDateRangeNavigator, {
  FixedDateRangeNavigatorActions,
  FixedDateRangeNavigatorProps
} from './FixedDateRangeNavigator';

export const mapStateToProps: MapStateToProps<
  FixedDateRangeNavigatorProps & DateRangeNavigatorFunctions,
  any,
  ApplicationState
> = (state, ownProps) => {
  const { startDate, endDate } = state.timeline;
  const navigatorFunctions = Selectors.getDateRangeNavigatorFunctions(state);
  return {
    startDate,
    endDate,
    ...navigatorFunctions
  };
};

export const mapDispatchToProps: MapDispatchToProps<FixedDateRangeNavigatorActions, any> = (dispatch: Dispatch, _) => {
  return {
    setRange: (startDate: Date, endDate: Date) => dispatch(setRange(startDate, endDate))
  };
};

export const FixedDateRangeNavigatorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FixedDateRangeNavigator);



// WEBPACK FOOTER //
// ./src/components/navbar/FixedDateRangeNavigatorContainer.ts